import * as Types from '../../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { PatientCurrentVisitFragmentDoc } from './details-graphql.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PatientDetailsQueryVariables = Types.Exact<{
  uuid: Types.Scalars['String'];
  searchWholeTerritory?: Types.InputMaybe<Types.Scalars['Boolean']>;
}>;


export type PatientDetailsQuery = { readonly __typename?: 'Query', readonly patientByCardId?: { readonly __typename?: 'PatientByCardIdResult', readonly passportId?: string | null, readonly patient: { readonly __typename?: 'Patient', readonly uuid: string, readonly patientHasInsurance?: Types.PatientHasInsurance | null, readonly newToClinic?: string | null, readonly clinic: string, readonly organisation: string, readonly card?: { readonly __typename?: 'PatientCard', readonly id?: string | null, readonly url?: string | null } | null, readonly person: { readonly __typename?: 'Person', readonly dob: string, readonly gender: Types.Gender, readonly nationality?: string | null, readonly maritalStatus?: Types.MaritalStatus | null, readonly name: { readonly __typename?: 'Name', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null, readonly fullname?: string | null }, readonly addresses: ReadonlyArray<{ readonly __typename?: 'Address', readonly country?: string | null, readonly state?: string | null, readonly subCounty?: string | null, readonly ward?: string | null, readonly street?: string | null } | null>, readonly languages: ReadonlyArray<{ readonly __typename?: 'Language', readonly locale?: string | null } | null>, readonly contactPoints: ReadonlyArray<{ readonly __typename?: 'ContactPoint', readonly system: Types.ContactPointSystem, readonly ownership?: Types.ContactPointOwnership | null, readonly value: string } | null>, readonly contacts: ReadonlyArray<{ readonly __typename?: 'Contact', readonly relationship: Types.ContactRelationship, readonly name?: { readonly __typename?: 'Name', readonly firstname?: string | null, readonly middlename?: string | null, readonly lastname?: string | null, readonly fullname?: string | null } | null, readonly contactPoints: ReadonlyArray<{ readonly __typename?: 'ContactPoint', readonly system: Types.ContactPointSystem, readonly value: string } | null>, readonly address?: { readonly __typename?: 'Address', readonly country?: string | null, readonly state?: string | null, readonly subCounty?: string | null, readonly ward?: string | null, readonly street?: string | null } | null } | null> }, readonly insurance?: { readonly __typename?: 'Insurance', readonly insuranceType: string, readonly insuranceNumber?: string | null, readonly paymentUpToDate?: boolean | null, readonly expiryDate?: string | null, readonly insuranceDetails?: unknown | null, readonly visitValidation?: { readonly __typename?: 'PatientInsuranceVisitValidation', readonly expiryStrategy?: string | null } | null, readonly insuranceProvider?: { readonly __typename?: 'InsuranceProvider', readonly name?: string | null, readonly visitValidation?: { readonly __typename?: 'InsuranceVisitValidation', readonly expiryStrategy: Types.VisitExpiryStrategy } | null } | null } | null, readonly education?: { readonly __typename?: 'Education', readonly isStudent: boolean, readonly school?: string | null, readonly nemisNumber?: string | null } | null, readonly consent: { readonly __typename?: 'Consent', readonly elephantUseOfAnonData: boolean, readonly productMarketing: boolean, readonly territoryUseOfData: boolean, readonly accessToHealthRecords: boolean, readonly healthcareComms: boolean }, readonly currentVisit?: { readonly __typename?: 'Visit', readonly _id: string, readonly expiryStrategy?: Types.VisitExpiryStrategy | null, readonly admissionEvent?: { readonly __typename?: 'VisitCareEvent', readonly _id?: string | null, readonly type?: Types.VisitCareEventAction | null } | null, readonly insuranceList?: ReadonlyArray<{ readonly __typename?: 'InsuranceListItem', readonly isValidForVisit?: boolean | null, readonly visitInsuranceDetails?: unknown | null, readonly insurance: { readonly __typename?: 'VisitInsurance', readonly insuranceProvider?: { readonly __typename?: 'InsuranceProvider', readonly name?: string | null, readonly insuranceType?: string | null, readonly visitValidation?: { readonly __typename?: 'InsuranceVisitValidation', readonly expiryStrategy: Types.VisitExpiryStrategy } | null } | null } } | null> | null } | null, readonly registrationPayment: { readonly __typename?: 'RegistrationPaymentOverview', readonly status: Types.PaymentStatus } } } | null };

export type GetClinicQueryVariables = Types.Exact<{
  clinicId: Types.Scalars['String'];
}>;


export type GetClinicQuery = { readonly __typename?: 'Query', readonly clinic?: { readonly __typename?: 'Clinic', readonly uuid: string, readonly name: string } | null };

export type OrganisationQueryVariables = Types.Exact<{
  organisationId: Types.Scalars['String'];
}>;


export type OrganisationQuery = { readonly __typename?: 'Query', readonly organisation?: { readonly __typename?: 'Organisation', readonly name: string, readonly uuid: string } | null };


export const PatientDetailsDocument = gql`
    query PatientDetails($uuid: String!, $searchWholeTerritory: Boolean) {
  patientByCardId(uuid: $uuid, searchWholeTerritory: $searchWholeTerritory) {
    patient {
      uuid
      card {
        id
        url
      }
      person {
        name {
          firstname
          middlename
          lastname
          fullname
        }
        dob
        gender
        addresses {
          country
          state
          subCounty
          ward
          street
        }
        nationality
        languages {
          locale
        }
        maritalStatus
        contactPoints {
          system
          ownership
          value
        }
        contacts {
          name {
            firstname
            middlename
            lastname
            fullname
          }
          relationship
          contactPoints {
            system
            value
          }
          address {
            country
            state
            subCounty
            ward
            street
          }
        }
      }
      patientHasInsurance
      insurance {
        insuranceType
        insuranceNumber
        paymentUpToDate
        expiryDate
        visitValidation {
          expiryStrategy
        }
        insuranceProvider {
          name
          visitValidation {
            expiryStrategy
          }
        }
        insuranceDetails
      }
      education {
        isStudent
        school
        nemisNumber
      }
      consent {
        elephantUseOfAnonData
        productMarketing
        territoryUseOfData
        accessToHealthRecords
        healthcareComms
      }
      newToClinic
      clinic
      currentVisit {
        ...PatientCurrentVisit
      }
      registrationPayment {
        status
      }
      organisation
    }
    passportId
  }
}
    ${PatientCurrentVisitFragmentDoc}`;

/**
 * __usePatientDetailsQuery__
 *
 * To run a query within a React component, call `usePatientDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientDetailsQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      searchWholeTerritory: // value for 'searchWholeTerritory'
 *   },
 * });
 */
export function usePatientDetailsQuery(baseOptions: Apollo.QueryHookOptions<PatientDetailsQuery, PatientDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientDetailsQuery, PatientDetailsQueryVariables>(PatientDetailsDocument, options);
      }
export function usePatientDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientDetailsQuery, PatientDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientDetailsQuery, PatientDetailsQueryVariables>(PatientDetailsDocument, options);
        }
export type PatientDetailsQueryHookResult = ReturnType<typeof usePatientDetailsQuery>;
export type PatientDetailsLazyQueryHookResult = ReturnType<typeof usePatientDetailsLazyQuery>;
export type PatientDetailsQueryResult = Apollo.QueryResult<PatientDetailsQuery, PatientDetailsQueryVariables>;
export const GetClinicDocument = gql`
    query getClinic($clinicId: String!) {
  clinic(id: $clinicId) {
    uuid
    name
  }
}
    `;

/**
 * __useGetClinicQuery__
 *
 * To run a query within a React component, call `useGetClinicQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClinicQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClinicQuery({
 *   variables: {
 *      clinicId: // value for 'clinicId'
 *   },
 * });
 */
export function useGetClinicQuery(baseOptions: Apollo.QueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
      }
export function useGetClinicLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClinicQuery, GetClinicQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClinicQuery, GetClinicQueryVariables>(GetClinicDocument, options);
        }
export type GetClinicQueryHookResult = ReturnType<typeof useGetClinicQuery>;
export type GetClinicLazyQueryHookResult = ReturnType<typeof useGetClinicLazyQuery>;
export type GetClinicQueryResult = Apollo.QueryResult<GetClinicQuery, GetClinicQueryVariables>;
export const OrganisationDocument = gql`
    query Organisation($organisationId: String!) {
  organisation(id: $organisationId) {
    name
    uuid
  }
}
    `;

/**
 * __useOrganisationQuery__
 *
 * To run a query within a React component, call `useOrganisationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganisationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganisationQuery({
 *   variables: {
 *      organisationId: // value for 'organisationId'
 *   },
 * });
 */
export function useOrganisationQuery(baseOptions: Apollo.QueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
      }
export function useOrganisationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganisationQuery, OrganisationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganisationQuery, OrganisationQueryVariables>(OrganisationDocument, options);
        }
export type OrganisationQueryHookResult = ReturnType<typeof useOrganisationQuery>;
export type OrganisationLazyQueryHookResult = ReturnType<typeof useOrganisationLazyQuery>;
export type OrganisationQueryResult = Apollo.QueryResult<OrganisationQuery, OrganisationQueryVariables>;